import { IntroHeaderProps } from '@/components/intro-header/type';
import { Headline } from '@/components/headline/Headline';
import React from 'react';
import SerializeDescription from '@/components/serialize-description/SerializeDescription';
import clsx from 'clsx';

export const IntroHeader: React.FC<IntroHeaderProps> = ({
  headline,
  description,
  sectionBackgroundColor,
  extraSpacing,
}) => (
  <div
    className={clsx(
      `intro-header-element w-full bg-${sectionBackgroundColor}`,
      extraSpacing ? 'py-24' : 'single-content py-4',
    )}
  >
    <div className="container mx-auto grid grid-cols-12 gap-6 px-4 sm:px-0">
      <div className="col-start-1 col-end-13 flex flex-col gap-6 lg:col-start-2 lg:col-end-12 xl:col-start-3 xl:col-end-11">
        <div className="smzh-intro-header flex flex-col gap-6 text-brand-700">
          <Headline
            {...headline}
            className={clsx({ '!my-0': !extraSpacing }, '-ml-0.5')}
          />
          {description && <SerializeDescription description={description} />}
        </div>
      </div>
    </div>
  </div>
);
